import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-arrow-button',
  templateUrl: './arrow-button.component.html',
  styleUrls: ['./arrow-button.component.scss']
})
export class ArrowButtonComponent {

  @Input() rotated: boolean = false;

  @Input() outline: boolean = false;

  @Input() disabled: boolean = false;
}
